import { Injectable } from '@angular/core';
import { Address } from "@models/address/address";
import { IAddressParseResponse } from "@models/address/address-parse-response";
import BaseApiService from "@shared/services/base/base-api.service";
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuxiliaryApiService extends BaseApiService {
  getParseAddress(fullAddress: string, countryCode: string | undefined = "au"): Observable<IAddressParseResponse> {
    const encodedAddress = encodeURIComponent(fullAddress);
    return this.api.get<IAddressParseResponse>(`${ this.apiUrl }/services/address/parse/${ countryCode }/${ encodedAddress }`)
      .pipe(map(({ address, valid }) => ({ valid, address: new Address(address) })));
  }

  searchAddress(term: string): Observable<string[]> {
    const encodedTerm = encodeURIComponent(term);
    return this.api.get<string[]>(`${ this.apiUrl }/services/address/autocomplete/${ encodedTerm }`);
  }

  searchAddressGlobal(term: string, country: string): Observable<string[]> {
    const encodedTerm = encodeURIComponent(term);
    return this.api.get<string[]>(`${ this.apiUrl }/services/address/autocomplete/global/${ country }/${ encodedTerm }`);
  }

  getCompanyNameByACn(acn: string) {
    return this.api.get<{ entityName: string, entityId: string }>(`${ this.apiUrl }/services/lookup-acn/${ acn }`);
  }
}
